"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cssinjs = require("@ant-design/cssinjs");
var genPickerStyle = function genPickerStyle(token) {
  var componentCls = token.componentCls,
    controlHeightLG = token.controlHeightLG,
    borderRadiusSM = token.borderRadiusSM,
    colorPickerInsetShadow = token.colorPickerInsetShadow,
    marginSM = token.marginSM,
    colorBgElevated = token.colorBgElevated,
    colorFillSecondary = token.colorFillSecondary,
    lineWidthBold = token.lineWidthBold,
    colorPickerHandlerSize = token.colorPickerHandlerSize;
  return _defineProperty(_defineProperty({
    userSelect: 'none'
  }, "".concat(componentCls, "-select"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-palette"), {
    minHeight: token.calc(controlHeightLG).mul(4).equal(),
    overflow: 'hidden',
    borderRadius: borderRadiusSM
  }), "".concat(componentCls, "-saturation"), {
    position: 'absolute',
    borderRadius: 'inherit',
    boxShadow: colorPickerInsetShadow,
    inset: 0
  }), "marginBottom", marginSM)), "".concat(componentCls, "-handler"), {
    width: colorPickerHandlerSize,
    height: colorPickerHandlerSize,
    border: "".concat((0, _cssinjs.unit)(lineWidthBold), " solid ").concat(colorBgElevated),
    position: 'relative',
    borderRadius: '50%',
    cursor: 'pointer',
    boxShadow: "".concat(colorPickerInsetShadow, ", 0 0 0 1px ").concat(colorFillSecondary)
  });
};
var _default = exports["default"] = genPickerStyle;